import React, { useState } from 'react';
import supabase from '../supabase';
import { fetchPayouts } from '../api';
import './Login.css';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password.trim()) {
      setError('Enter your email and password');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const { data, error: authError } = await supabase.auth.signInWithPassword({
        email: email.trim(),
        password: password.trim()
      });

      if (authError) {
        setError(authError.message);
        setIsLoading(false);
        return;
      }

      // Verify admin access before allowing in
      try {
        await fetchPayouts(data.session.access_token, '');
      } catch (adminErr) {
        if (adminErr.message === 'FORBIDDEN') {
          await supabase.auth.signOut();
          setError('Access denied. This account is not authorized for admin access.');
          setIsLoading(false);
          return;
        }
      }

      onLogin(data.session);
    } catch (err) {
      setError('Something went wrong. Try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src="/darkTlogo.png" alt="Tchpack" className="login-logo-img" />
        </div>
        <h1>Tchpack Admin</h1>
        <p className="login-subtitle">Sign in with your Tchpack account</p>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            className="login-input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
          />
          <input
            type="password"
            className="login-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && <span className="login-error">{error}</span>}
          <button type="submit" className="login-btn" disabled={isLoading}>
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
